<div class="container">
  <div class="row">
    <h1 class="message"> {{Message}} </h1>
  </div>

  <h3>
    Reset Password
  </h3>

  <hr />
  <form class="form-horizontal" [formGroup]="resetForm" (ngSubmit)="changePassword(resetForm.value)">
    @if(Message){
      <div class="row message" [ngClass]="{'label-success':!Error,'label-danger':Error}">
        {{Message}}
      </div>
    }
    <div class="row">
      <div class="form-group">
        <div class="col-lg-3"><label>New Password</label></div>
        <div class="col-lg-9">
          <input type="password" class="form-group" formControlName="password" name="password" id="password" />
          @if(resetForm.controls['password'].errors && resetForm.controls['password'].errors['required'] && resetForm.controls['password'].touched){
          <em class="text-danger">Required!</em>
          }
          @if(resetForm.controls['password'].errors && resetForm.controls['password'].errors['pattern']){
          <em class="text-danger">The password must contain uppercase, lowercase, numeric, one of [ #$^+=!*()&#64;%&)] , and be at least 8 characters!</em>
          }
        </div>
      </div>
      <div class="form-group">
        <div class="col-lg-3"><label>Confirm Password</label></div>
        <div class="col-lg-9">
          <input type="password" class="form-group" formControlName="confirmPassword" name="confirmPassword" />
          @if(!isMatch() && resetForm.controls['confirmPassword'].touched) {
          <em class="text-danger">The password doesn't match!</em>
          }
        </div>
      </div>
      <div class="form-group">
        <div class="col-lg-3">
        </div>
        <div class="col-lg-9 no-left-padding">
          <input type="submit" value="Submit" class="btn btn-success" [disabled]="!IsValid()" />
        </div>
      </div>
    </div>
  </form>
</div>
